
    // this file was auto generated by python script
    import Printer from './Printer';
    export default Printer;
    